import { css } from '@emotion/react';
import type { ModalDialogProps } from '@mui/joy';
import { ModalDialog, styled } from '@mui/joy';

const StyledModalDialog = styled(ModalDialog)(
  ({ theme }) => css`
    text-align: center;
    --Card-padding: ${theme.spacing(3)};
  `,
);

export function IllustrationModalDialog(props: ModalDialogProps) {
  return <StyledModalDialog maxWidth={400} {...props} />;
}
